import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Form,
  FormGroup,
  FormField,
  Button,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardBillingDepositHistoryUX = (props: any) => {
    return(
      <div
        id="CardBillingDepositHistoryUX-div-0"
        style={{ display: "flex", flexDirection: "column" }}>
        <div
          id="CardBillingDepositHistoryUX-div-130"
          style={{ display:  "flex", justifyContent: "space-between",  padding: "10px 10px 0px 10px"  }}>
          
          <div
            id="CardBillingDepositHistoryUX-div-132"
            style={{ fontSize: "1.2rem", fontWeight: "bold",display: "flex", alignItems: "center" }}>
            {props.languageUX === "en" ? "Deposit History" : "ประวัติการใช้เงินมัดจำ"}
          </div>
          <div
            id="CardBillingDepositHistoryUX-div-133"
            style={{ fontSize: "1.2rem", fontWeight: "bold",display: "flex", alignItems: "center" }}>
            
          </div>
        </div>
        <div
          id="CardBillingDepositHistoryUX-div-131"
          style={{padding: "0px 10px 10px 10px", display: props.viewMode ? "none" : "" }}>
          
          <hr
            id="CardBillingDepositHistoryUX-hr-134">
          </hr>
        </div>
        <div
          id="CardBillingDepositHistoryUX-div-135">
          
          <Form
            id="CardBillingDepositHistoryUX-Form-138">
            <FormGroup
              id="CardBillingDepositHistoryUX-FormGroup-139"
              inline={true}
              style={{ display: "flex", margin: "10px 15px"  }}>
              <FormField
                id="CardBillingDepositHistoryUX-FormField-140">
                <div
                  id="CardBillingDepositHistoryUX-div-145">
                  {props.languageUX === "en" ? "Deposit Document Code" : "รหัสเอกสารเงินมัดจำ"}
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositHistoryUX-FormField-141">
                <div
                  id="CardBillingDepositHistoryUX-div-147">
                  
                  <Input
                    id="CardBillingDepositHistoryUX-Input-157"
                    name="receiptNo"
                    onChange={props.onChange}
                    value={props.depositHistory?.receiptNo}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositHistoryUX-FormField-155">
                <div
                  id="CardBillingDepositHistoryUX-div-156"
                  style={{ marginLeft: "40px" }}>
                  {props.languageUX === "en" ? "date" : "วันที่"}
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositHistoryUX-FormField-142">
                <div
                  id="CardBillingDepositHistoryUX-div-148">
                  
                  <DateTextBox
                    id="CardBillingDepositHistoryUX-DateTextBox-153"
                    onChange={props.onChangeStartDate}
                    value={props.startDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositHistoryUX-FormField-143">
                <div
                  id="CardBillingDepositHistoryUX-div-149">
                  
                  <DateTextBox
                    id="CardBillingDepositHistoryUX-DateTextBox-152"
                    onChange={props.onChangeEndDate}
                    value={props.endDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositHistoryUX-FormField-144">
                <div
                  id="CardBillingDepositHistoryUX-div-150">
                  
                  <Button
                    color="blue"
                    id="CardBillingDepositHistoryUX-Button-151"
                    onClick={props.onSearchDepositHistory}
                    size="small">
                    {props.languageUX === "en" ? "Search" : "ค้นหา"}
                  </Button>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardBillingDepositHistoryUX-div-158"
          style={{ fontSize: "1.2rem", fontWeight: "bold", display: "flex", justifyContent: "flex-end", margin: "5px 10px 0px"  }}>
          {`ยอดเงินมัดจำคงเหลือรวม ${props.depositHistory?.depositTotal || "0.00"} บาท`}
        </div>
        <div
          id="CardBillingDepositHistoryUX-div-136"
          style={{ margin: "10px 10px 30px" }}>
          
          <Table
            data={props.depositHistoryData}
            headers="วันที่-เวลาที่ชำระ,เลขที่ใบเสร็จ ที่ชำระด้วยเงินมัดจำ,รหัสเอกสารเงินมัดจำ,ประเภทการรักษา,ยอดเงินที่ตัดใช้,เจ้าหน้าที่ผู้รับชำระ,,"
            id="CardBillingDepositHistoryUX-Table-137"
            keys="paymentDatetime,paymentReceipt,depositReceipt,encounterType,payment,paymentCashier,buttonDetail,buttonPrint"
            minRows="10"
            showPagination={false}>
          </Table>
        </div>
      </div>
    )
}


export default CardBillingDepositHistoryUX

export const screenPropsDefault = {"by":"order","title":"MEDICAL FEE","titleDescription":"ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"}

/* Date Time : Wed Oct 01 2025 11:54:21 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", flexDirection: \"column\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{ display:  \"flex\", justifyContent: \"space-between\",  padding: \"10px 10px 0px 10px\"  }"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 10px 10px 10px\", display: props.viewMode ? \"none\" : \"\" }"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการใช้เงินมัดจำ",
          "valueEN": "Deposit History"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-133"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "hr",
      "parent": 131,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-hr-134"
        }
      },
      "seq": 134,
      "void": true
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-135"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px 10px 30px\" }"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 137,
      "name": "Table",
      "parent": 136,
      "props": {
        "data": {
          "type": "code",
          "value": "props.depositHistoryData"
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "วันที่-เวลาที่ชำระ,เลขที่ใบเสร็จ ที่ชำระด้วยเงินมัดจำ,รหัสเอกสารเงินมัดจำ,ประเภทการรักษา,ยอดเงินที่ตัดใช้,เจ้าหน้าที่ผู้รับชำระ,,"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-Table-137"
        },
        "keys": {
          "type": "value",
          "value": "paymentDatetime,paymentReceipt,depositReceipt,encounterType,payment,paymentCashier,buttonDetail,buttonPrint"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "Form",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-Form-138"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "FormGroup",
      "parent": 138,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-FormGroup-139"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", margin: \"10px 15px\"  }"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-FormField-140"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-FormField-141"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-FormField-142"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-FormField-143"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-FormField-144"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 140,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสเอกสารเงินมัดจำ",
          "valueEN": "Deposit Document Code"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-145"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-147"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-148"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 143,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-149"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 144,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-150"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "Button",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-Button-151"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearchDepositHistory"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 152,
      "name": "DateTextBox",
      "parent": 149,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-DateTextBox-152"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 153,
      "name": "DateTextBox",
      "parent": 148,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-DateTextBox-153"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-FormField-155"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "date"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"40px\" }"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "Input",
      "parent": 147,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-Input-157"
        },
        "name": {
          "type": "value",
          "value": "receiptNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "value": {
          "type": "code",
          "value": "props.depositHistory?.receiptNo"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 158,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "`ยอดเงินมัดจำคงเหลือรวม ${props.depositHistory?.depositTotal || \"0.00\"} บาท`"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-158"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\", display: \"flex\", justifyContent: \"flex-end\", margin: \"5px 10px 0px\"  }"
        }
      },
      "seq": 136,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardBillingDepositHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "by": "order",
    "title": "MEDICAL FEE",
    "titleDescription": "ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"
  },
  "width": 80
}

*********************************************************************************** */
